/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHourglassEmpty = createReactComponent("outline", "hourglass-empty", "IconHourglassEmpty", [["path", { "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z", "key": "svg-0" }], ["path", { "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z", "key": "svg-1" }]]);

export { IconHourglassEmpty as default };
//# sourceMappingURL=IconHourglassEmpty.mjs.map
